import { useState } from 'react';
import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import ServerIPSection from './components/ServerIPSection';
import DiscordSection from './components/DiscordSection';
import ShopSection from './components/ShopSection';
import SpawnersSection from './components/SpawnersSection';
import Footer from './components/Footer';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-gradient-to-b from-[#0a0118] via-[#1a0b2e] to-[#0a0118]">
      <Navbar />
      <HeroSection />
      <AboutSection />
      <ServerIPSection />
      <DiscordSection />
      <ShopSection />
      <SpawnersSection />
      <Footer />
    </div>
  );
}
